import axios from "axios";
import { Maybe } from "shared";
import { getRestUrl } from "@web/utils/env/getRestUrl";

type ResponseBody = {
  success: boolean;
};

export async function postLogout(): Promise<Maybe<ResponseBody>> {
  try {
    const { data } = await axios.post<ResponseBody>(
      getRestUrl("logout"),
      {},
      {
        // Needed so session cookie gets unset
        withCredentials: true,
      }
    );
    return data;
  } catch {
    return null;
  }
}
